import { render } from "./DateController.vue?vue&type=template&id=678e565a"
import script from "./DateController.vue?vue&type=script&lang=js"
export * from "./DateController.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__